import {Layout, Divider, Image, Typography} from 'antd';
import React from 'react';
import appColors from '../../style/theme';

const {Text, Paragraph} = Typography;
const Content = Layout;
const Tres = () => {
  return (
    <Layout style={{margin: '5.2vh', background: 'transparent'}}>
      <Content style={{background: 'inherit'}}>
        <Paragraph className='Title3' style={{color: appColors['ColorX'], marginTop: '0vh'}}>Accelerated aging and age-related diseases</Paragraph>
        <Text className='BaseText2'>Aging can be defined as a complex network of cellular and molecular interactions that leads to a progressive decrease in physiological functions [10, 11]. It&apos;s a process with a high degree of <b> heterogeneity among individuals</b>, meaning that everyone ages at a different rate [12]. One person might have an accelerated or decelerated aging process, depending on several factors such as genetics, environment and lifestyle. The interaction of these factors is what determines the<q><b> “biological age”</b></q>. An example of this are the people who are the same age, but look very different, as it is shown on figure 5. Taking this into account, it is urgent to identify biomarkers that give information about the biological age in order to <b> predict trajectories of unhealthy aging </b>and evaluate the risk of developing age related diseases [4, 12].</Text>
        <Content style={{marginLeft: 'auto', marginRight: 'auto', maxWidth: '65%', background: 'inherit', marginTop: '2%'}}>
          <Image src='https://static.igem.wiki/teams/4464/wiki/project-description/5-famous-people.png' preview={false}/>
          <p>Fig. 5 Example of 4 different famous people comparing their ages</p>
        </Content>
      </Content>
      <Divider/>
    </Layout>
  );
};

export default Tres;
